import { render, staticRenderFns } from "./yorumDetay.vue?vue&type=template&id=708cffc3&scoped=true&"
import script from "./yorumDetay.vue?vue&type=script&lang=js&"
export * from "./yorumDetay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cffc3",
  null
  
)

export default component.exports